import { render, staticRenderFns } from "./ViewBillingChangeRequestsLegacy.vue?vue&type=template&id=fbded840"
import script from "./ViewBillingChangeRequestsLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewBillingChangeRequestsLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports